import { gqlMutate, gqlQuery } from './common/apolloClient'

import { gqlEditarDadoPagamento } from './queries/recharges'
import {
  gqlConsultarFormasPagamento,
  gqlAutorizaEditarFormaPagamentoDataVencimento,
  gqlConsultarDataVencimento,
  gqlEditarFormaPagamento,
  gqlEditarDataVencimento
} from './queries/payment-type'

export async function editPaymentMethod(data) {
  const {
    conta,
    numeroMascarado,
    validade,
    bandeira,
    alias,
    nome,
    paymentToken,
    cvv,
    valorRecarga
  } = data.dados
  await gqlMutate(gqlEditarDadoPagamento, {
    conta,
    numeroMascarado,
    validade,
    bandeira,
    alias,
    nome,
    paymentToken,
    cvv,
    valorRecarga: `${valorRecarga}`,
    ativo: true
  })
  // TODO Descobrir qual deve ser o retorno desta função: resp.result.msgRecarga ????
}

export async function getPaymentType() {
  const resp = await gqlQuery(gqlConsultarFormasPagamento)
  return resp.data.ConsultarFormasPagamento
}

export async function getEditAuthorizationPayment(type, accountPlanId) {
  const resp = await gqlQuery(gqlAutorizaEditarFormaPagamentoDataVencimento, {
    tipo: type,
    idConta: accountPlanId
  })

  return resp.data.AutorizaEditarFormaPagamentoDataVencimento
  // FIXME Qual o retorno desta função?
}

export async function getDueDate() {
  const resp = await gqlQuery(gqlConsultarDataVencimento)
  return resp.data.ConsultarDataVencimento
}

export async function editPaymentMethodWithoutRecharge(data) {
  const resp = await gqlMutate(gqlEditarFormaPagamento, data.dados)
  return resp.data.EditarFormaPagamento
}

export function editDueDate(data) {
  return gqlMutate(gqlEditarDataVencimento, data)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/editPaymentDataService.js